export const I18N_CHANGE_LOCALE_MUTATION_KEY = 'change-locale';
export const I18N_CHANGE_URL = 'anonym/translate/locale';
export const TRANSLATION_GROUP_INTERFACE_LANGUAGES = Symbol('interface.languages');
export const TRANSLATION_GROUP_INTERFACE_TOASTS = Symbol('interface.toasts');
export const TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK = Symbol('interface.confirm-open-link');

export const I18N_GET_TRANSLATIONS_URL = 'anonym/translate/locals_list';
export const I18N_GET_TRANSLATIONS_QUERY_KEY = 'i18n.translations';
